exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".atm-make-status-toggle {\n  margin-left: 10px;\n  margin-right: 10px; }\n\n.atm-makes-table th,\n.atm-makes-table td {\n  vertical-align: middle !important; }\n\n.atm-make-name-cell {\n  min-width: 220px; }\n\n.atm-make-status-cell {\n  min-width: 150px;\n  text-align: center; }\n\n.atm-make-status-text {\n  font-weight: 600;\n  margin-bottom: 6px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/service_settings/atm-makes/atm-makes.scss
// module id = 1086
// module chunks = 1